export { default } from './ContentTemplate';
export * from './ContentTemplate.types';
